import Scene from './Scene.js'
import { Button, Dialog, Modal } from 'react-aria-components'

export default function Reader ({ scene, onClose, isOpen, sceneArt, storyIcon }) {
  return (
    <Modal isOpen={isOpen} isDismissable={false} className='flex z-1000 fixed top-0 h-dvh w-screen'>
      <div className='flex-1 backdrop-blur-xs' />
      <Dialog className='flex-11 md:flex-3 bg-white p-1 mb-16 h-100% overflow-scroll'>
        <div className='font-mono h mx2'>
          <Scene scene={scene} sceneArt={sceneArt} storyIcon={storyIcon} />
        </div>
        <Button onPress={onClose} className='mt-4 mx-auto block w-2/3 md:w-1/2 py-2 text-center hover:bg-green-200 outline-black border-solid border rounded-sm'>
          Continue
        </Button>
        <div className='h-20' />
      </Dialog>
      <div className='flex-1 backdrop-blur-xs' />
    </Modal>
  )
}
